<script>
import { mapGetters } from 'vuex';
import MentionBox from '../mentions/MentionBox.vue';

export default {
  components: { MentionBox },
  props: {
    searchKey: {
      type: String,
      default: '',
    },
  },
  emits: ['replace', 'attach-media'],
  computed: {
    ...mapGetters({
      cannedMessages: 'getCannedResponses',
    }),
    items() {
      return this.cannedMessages.map(cannedMessage => ({
        label: cannedMessage.short_code,
        key: cannedMessage.short_code,
        description: cannedMessage.content || '',
        attachmentUrl: cannedMessage.attachment_url,
        attachmentContentType: cannedMessage.attachment_content_type,
        hasMedia: !!cannedMessage.attachment_url,
        mediaIcon: this.getMediaIcon(cannedMessage.attachment_content_type),
      }));
    },
  },
  watch: {
    searchKey() {
      this.fetchCannedResponses();
    },
  },
  mounted() {
    this.fetchCannedResponses();
  },
  methods: {
    getMediaIcon(contentType) {
      if (!contentType) return null;
      if (contentType.startsWith('image/')) return 'i-lucide-image';
      if (contentType.startsWith('video/')) return 'i-lucide-video';
      if (contentType.startsWith('audio/')) return 'i-lucide-audio-lines';
      return 'i-lucide-paperclip';
    },
    fetchCannedResponses() {
      this.$store.dispatch('getCannedResponse', { searchKey: this.searchKey });
    },
    handleMentionClick(item = {}) {
      this.$emit('replace', item.description);
      if (item.attachmentUrl) {
        this.$emit('attach-media', {
          url: item.attachmentUrl,
          contentType: item.attachmentContentType,
        });
      }
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <MentionBox
    v-if="items.length"
    :items="items"
    @mention-select="handleMentionClick"
  />
</template>
